var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: "100%",
    width: "100%",
    viewBox: "0 0 1125 875",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "1.335s",
    begin: "0s",
    fill: "freeze",
    values: "1; 1; 0; 0",
    keyTimes: "0; 0.3985; 0.675; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(412,565)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    repeatCount: "indefinite",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    keyTimes: "0; 0.15; 0.325; 0.4735; 0.675; 1",
    keySplines: "0 0 1 1; 0.333 0 0.833 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    keyPoints: "0; 0; 0.168; 0.474; 1; 1",
    path: "M0 0 C0 0 -14 -86 0 -154 C14 -222 116 -344 188 -348 C282 -348 400 -176 466 24",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-67)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    values: "-67; -67; 361; 657; 657",
    keyTimes: "0; 0.15; 0.261225; 0.55; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.36,1.36)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    values: "1.36 1.36; 1.36 1.36; 0.951 0.951; 0.86 0.86; 0.86 0.86",
    keyTimes: "0; 0.15; 0.261225; 0.55; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-249.739,-250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,251.411,246.074)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f0d54a",
    d: "M25.517,10.253C24.123,13.722,11.569,11.943,-2.524,6.281C-16.617,0.619,-26.911,-6.784,-25.518,-10.252C-24.124,-13.722,-11.57,-11.943,2.523,-6.281C16.616,-0.619,26.912,6.783,25.517,10.253Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,249.675,250.393)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f0d54a",
    d: "M23.783,14.571C23.783,14.571,-27.252,-5.934,-27.252,-5.934C-27.252,-5.934,-23.782,-14.571,-23.782,-14.571C-23.782,-14.571,27.252,5.934,27.252,5.934C27.252,5.934,23.783,14.571,23.783,14.571Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,248.256,253.926)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d1770f",
    d: "M25.518,10.253C24.124,13.722,11.57,11.943,-2.523,6.281C-16.616,0.619,-26.911,-6.784,-25.517,-10.252C-24.123,-13.722,-11.568,-11.943,2.524,-6.281C16.618,-0.619,26.912,6.783,25.518,10.253Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,248.155,254.176)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#af5700",
    d: "M19.641,7.891C18.786,10.021,9.298,8.215,-1.549,3.857C-12.396,-0.502,-20.497,-5.761,-19.641,-7.891C-18.785,-10.021,-9.298,-8.215,1.549,-3.857C5.284,-2.356,8.694,-0.75,11.524,0.8C16.913,3.751,20.202,6.494,19.641,7.891Z"
  })))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "1.335s",
    begin: "0s",
    fill: "freeze",
    values: "1; 1; 0; 0",
    keyTimes: "0; 0.525; 0.775; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(638,599)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    repeatCount: "indefinite",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    keyTimes: "0; 0.325; 0.6; 0.775; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    keyPoints: "0; 0; 0.367; 1; 1",
    path: "M0 0 C0 0 -50 -212 -204 -218 C-352 -208 -528 -36 -550 162",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 0; 361; 657; 657",
    keyTimes: "0; 0.3; 0.55; 0.774999; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 1 1; 0.6 0.6; 0.4 0.4; 0.4 0.4",
    keyTimes: "0; 0.3; 0.5; 0.75; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-249.739,-250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,251.411,246.074)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f0d54a",
    d: "M25.517,10.253C24.123,13.722,11.569,11.943,-2.524,6.281C-16.617,0.619,-26.911,-6.784,-25.518,-10.252C-24.124,-13.722,-11.57,-11.943,2.523,-6.281C16.616,-0.619,26.912,6.783,25.517,10.253Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,249.675,250.393)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f0d54a",
    d: "M23.783,14.571C23.783,14.571,-27.252,-5.934,-27.252,-5.934C-27.252,-5.934,-23.782,-14.571,-23.782,-14.571C-23.782,-14.571,27.252,5.934,27.252,5.934C27.252,5.934,23.783,14.571,23.783,14.571Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,248.256,253.926)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d1770f",
    d: "M25.518,10.253C24.124,13.722,11.57,11.943,-2.523,6.281C-16.616,0.619,-26.911,-6.784,-25.517,-10.252C-24.123,-13.722,-11.568,-11.943,2.524,-6.281C16.618,-0.619,26.912,6.783,25.518,10.253Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,248.155,254.176)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#af5700",
    d: "M19.641,7.891C18.786,10.021,9.298,8.215,-1.549,3.857C-12.396,-0.502,-20.497,-5.761,-19.641,-7.891C-18.785,-10.021,-9.298,-8.215,1.549,-3.857C5.284,-2.356,8.694,-0.75,11.524,0.8C16.913,3.751,20.202,6.494,19.641,7.891Z"
  })))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "i6"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "1.335s",
    begin: "0s",
    fill: "freeze",
    values: "1; 1; 1; 0; 0",
    keyTimes: "0; 0.25; 0.375; 0.575; 1",
    keySplines: "0 0 1 1; 0.167 0 0.833 1; 0.333 0 0.667 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(551,619)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    repeatCount: "indefinite",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    keyTimes: "0; 0.175; 0.375; 0.575; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    keyPoints: "0; 0; 0.467; 1; 1",
    path: "M0 0 C0 0 -120 -122 -282 -132 C-412 -132 -468 -35 -488 120",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-33)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    values: "-33; -33; -403.524; -494; -494",
    keyTimes: "0; 0.175; 0.375; 0.575; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 0.896; 0.333 0.425 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.54,0.54)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    values: "0.54 0.54; 0.54 0.54; 0.39 0.39; 0.24 0.24; 0.24 0.24",
    keyTimes: "0; 0.175; 0.375; 0.575; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-818,-708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i7",
    transform: "matrix(1,0,0,1,818,717.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b94f01",
    d: "M109,0C109,47.221,60.199,85.5,0,85.5C-60.199,85.5,-109,47.221,-109,0C-109,-47.221,-60.199,-85.5,0,-85.5C60.199,-85.5,109,-47.221,109,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i8",
    transform: "matrix(1,0,0,1,818,703.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bc8d08",
    d: "M109,0C109,47.221,60.199,85.5,0,85.5C-60.199,85.5,-109,47.221,-109,0C-109,-47.221,-60.199,-85.5,0,-85.5C60.199,-85.5,109,-47.221,109,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i9",
    transform: "matrix(1,0,0,1,818,698.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#feea5b",
    d: "M109,0C109,47.221,60.199,85.5,0,85.5C-60.199,85.5,-109,47.221,-109,0C-109,-47.221,-60.199,-85.5,0,-85.5C60.199,-85.5,109,-47.221,109,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,818,698.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c38211",
    d: "M85,0C85,36.823,46.944,66.674,0,66.674C-46.944,66.674,-85,36.823,-85,0C-85,-36.823,-46.944,-66.674,0,-66.674C46.944,-66.674,85,-36.823,85,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,818,702.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#face24",
    d: "M85,0C85,36.823,46.944,66.674,0,66.674C-46.944,66.674,-85,36.823,-85,0C-85,-36.823,-46.944,-66.674,0,-66.674C46.944,-66.674,85,-36.823,85,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,820.657,696.529)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d1770f",
    d: "M20.847,32.113C20.847,32.113,23.681,40.272,23.681,40.272C23.681,40.272,3.467,41.426,3.467,41.426C3.467,41.426,0.633,33.266,0.633,33.266C-18.896,31.41,-31.295,21.539,-33.805,14.312C-33.805,14.312,-11.894,13.062,-11.894,13.062C-11.894,13.062,-7.971,21.634,6.842,20.79C14.866,20.332,20.708,16.313,19.372,12.467C16.538,4.31,-3.107,4.836,-8.791,4.328C-19.193,3.377,-36.991,1.064,-41.162,-10.941C-44.401,-20.265,-36.197,-28.814,-22.081,-32.116C-22.081,-32.116,-24.915,-40.274,-24.915,-40.274C-24.915,-40.274,-4.701,-41.427,-4.701,-41.427C-4.701,-41.427,-1.866,-33.269,-1.866,-33.269C15.145,-31.863,25.914,-24.87,28.384,-17.761C28.384,-17.761,7.553,-16.573,7.553,-16.573C6.987,-18.203,2.264,-21.381,-8.538,-20.765C-15.945,-20.342,-20.748,-16.503,-19.25,-12.191C-17.468,-7.062,-4.507,-7.801,0.519,-7.375C12.773,-6.53,35.414,-5.681,41.284,11.217C44.402,20.191,35.428,28.786,20.847,32.113Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,819.657,693.529)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fefb94",
    d: "M20.847,32.113C20.847,32.113,23.681,40.272,23.681,40.272C23.681,40.272,3.467,41.426,3.467,41.426C3.467,41.426,0.633,33.266,0.633,33.266C-18.896,31.41,-31.295,21.539,-33.805,14.312C-33.805,14.312,-11.894,13.062,-11.894,13.062C-11.894,13.062,-7.971,21.634,6.842,20.79C14.866,20.332,20.708,16.313,19.372,12.467C16.538,4.31,-3.107,4.836,-8.791,4.328C-19.193,3.377,-36.991,1.064,-41.162,-10.941C-44.401,-20.265,-36.197,-28.814,-22.081,-32.116C-22.081,-32.116,-24.915,-40.274,-24.915,-40.274C-24.915,-40.274,-4.701,-41.427,-4.701,-41.427C-4.701,-41.427,-1.866,-33.269,-1.866,-33.269C15.145,-31.863,25.914,-24.87,28.384,-17.761C28.384,-17.761,7.553,-16.573,7.553,-16.573C6.987,-18.203,2.264,-21.381,-8.538,-20.765C-15.945,-20.342,-20.748,-16.503,-19.25,-12.191C-17.468,-7.062,-4.507,-7.801,0.519,-7.375C12.773,-6.53,35.414,-5.681,41.284,11.217C44.402,20.191,35.428,28.786,20.847,32.113Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i10"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    stroke: "#ffffff",
    fill: "#7a8c99",
    d: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "i11"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    stroke: "#ffffff",
    fill: "#7a8c99",
    d: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "i12"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    stroke: "#ffffff",
    fill: "#7a8c99",
    d: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "i13"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    stroke: "#ffffff",
    fill: "#7a8c99",
    d: ""
  })))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "i14"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "1.335s",
    begin: "0s",
    fill: "freeze",
    values: "1; 1; 0; 0",
    keyTimes: "0; 0.375; 0.55; 1",
    keySplines: "0.167 0 0.833 1; 0.333 0 0.667 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(499,681)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    repeatCount: "indefinite",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    keyTimes: "0; 0.213775; 0.525; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    keyPoints: "0; 0.517; 1; 1",
    path: "M0 0 C0 0 32 -356 166 -382 C266 -390 404 -285 458 -132",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-62)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    values: "-62; 361; 657; 657",
    keyTimes: "0; 0.225; 0.5265; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.46,0.46)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    values: "0.46 0.46; 0.31 0.31; 0.16 0.16; 0.16 0.16",
    keyTimes: "0; 0.213775; 0.525; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-818,-708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i7",
    transform: "matrix(1,0,0,1,818,717.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b94f01",
    d: "M109,0C109,47.221,60.199,85.5,0,85.5C-60.199,85.5,-109,47.221,-109,0C-109,-47.221,-60.199,-85.5,0,-85.5C60.199,-85.5,109,-47.221,109,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i8",
    transform: "matrix(1,0,0,1,818,703.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bc8d08",
    d: "M109,0C109,47.221,60.199,85.5,0,85.5C-60.199,85.5,-109,47.221,-109,0C-109,-47.221,-60.199,-85.5,0,-85.5C60.199,-85.5,109,-47.221,109,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i9",
    transform: "matrix(1,0,0,1,818,698.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#feea5b",
    d: "M109,0C109,47.221,60.199,85.5,0,85.5C-60.199,85.5,-109,47.221,-109,0C-109,-47.221,-60.199,-85.5,0,-85.5C60.199,-85.5,109,-47.221,109,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,818,698.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c38211",
    d: "M85,0C85,36.823,46.944,66.674,0,66.674C-46.944,66.674,-85,36.823,-85,0C-85,-36.823,-46.944,-66.674,0,-66.674C46.944,-66.674,85,-36.823,85,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,818,702.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#face24",
    d: "M85,0C85,36.823,46.944,66.674,0,66.674C-46.944,66.674,-85,36.823,-85,0C-85,-36.823,-46.944,-66.674,0,-66.674C46.944,-66.674,85,-36.823,85,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,820.657,696.529)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d1770f",
    d: "M20.847,32.113C20.847,32.113,23.681,40.272,23.681,40.272C23.681,40.272,3.467,41.426,3.467,41.426C3.467,41.426,0.633,33.266,0.633,33.266C-18.896,31.41,-31.295,21.539,-33.805,14.312C-33.805,14.312,-11.894,13.062,-11.894,13.062C-11.894,13.062,-7.971,21.634,6.842,20.79C14.866,20.332,20.708,16.313,19.372,12.467C16.538,4.31,-3.107,4.836,-8.791,4.328C-19.193,3.377,-36.991,1.064,-41.162,-10.941C-44.401,-20.265,-36.197,-28.814,-22.081,-32.116C-22.081,-32.116,-24.915,-40.274,-24.915,-40.274C-24.915,-40.274,-4.701,-41.427,-4.701,-41.427C-4.701,-41.427,-1.866,-33.269,-1.866,-33.269C15.145,-31.863,25.914,-24.87,28.384,-17.761C28.384,-17.761,7.553,-16.573,7.553,-16.573C6.987,-18.203,2.264,-21.381,-8.538,-20.765C-15.945,-20.342,-20.748,-16.503,-19.25,-12.191C-17.468,-7.062,-4.507,-7.801,0.519,-7.375C12.773,-6.53,35.414,-5.681,41.284,11.217C44.402,20.191,35.428,28.786,20.847,32.113Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,819.657,693.529)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fefb94",
    d: "M20.847,32.113C20.847,32.113,23.681,40.272,23.681,40.272C23.681,40.272,3.467,41.426,3.467,41.426C3.467,41.426,0.633,33.266,0.633,33.266C-18.896,31.41,-31.295,21.539,-33.805,14.312C-33.805,14.312,-11.894,13.062,-11.894,13.062C-11.894,13.062,-7.971,21.634,6.842,20.79C14.866,20.332,20.708,16.313,19.372,12.467C16.538,4.31,-3.107,4.836,-8.791,4.328C-19.193,3.377,-36.991,1.064,-41.162,-10.941C-44.401,-20.265,-36.197,-28.814,-22.081,-32.116C-22.081,-32.116,-24.915,-40.274,-24.915,-40.274C-24.915,-40.274,-4.701,-41.427,-4.701,-41.427C-4.701,-41.427,-1.866,-33.269,-1.866,-33.269C15.145,-31.863,25.914,-24.87,28.384,-17.761C28.384,-17.761,7.553,-16.573,7.553,-16.573C6.987,-18.203,2.264,-21.381,-8.538,-20.765C-15.945,-20.342,-20.748,-16.503,-19.25,-12.191C-17.468,-7.062,-4.507,-7.801,0.519,-7.375C12.773,-6.53,35.414,-5.681,41.284,11.217C44.402,20.191,35.428,28.786,20.847,32.113Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i10"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    stroke: "#ffffff",
    fill: "#7a8c99",
    d: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "i11"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    stroke: "#ffffff",
    fill: "#7a8c99",
    d: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "i12"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    stroke: "#ffffff",
    fill: "#7a8c99",
    d: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "i13"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    stroke: "#ffffff",
    fill: "#7a8c99",
    d: ""
  })))))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "i15"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "1.335s",
    begin: "0s",
    fill: "freeze",
    values: "1; 1; 0; 0",
    keyTimes: "0; 0.35; 0.625; 1",
    keySplines: "0.167 0 0.833 1; 0.333 0 0.667 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,552)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    repeatCount: "indefinite",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    keyTimes: "0; 0.025; 0.325; 0.625; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    keyPoints: "0; 0; 0.479; 1; 1",
    path: "M0 0 C0 0 -96 -103 -266 -101 C-448 -97 -520 63 -520 63",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-142)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    values: "-142; 219; 260.225; 415; 415",
    keyTimes: "0; 0.161225; 0.35; 0.5; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 0; 0.333 0.416 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.83,0.83)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    values: "0.83 0.83; 0.6 0.6; 0.4 0.4; 0.4 0.4",
    keyTimes: "0; 0.161225; 0.5015; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-249.5,-249.462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i7",
    transform: "matrix(1,0,0,1,249.5,242.392)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#face24",
    d: "M63.5,0C63.5,17.932,35.07,32.468,0,32.468C-35.07,32.468,-63.5,17.932,-63.5,0C-63.5,-17.932,-35.07,-32.468,0,-32.468C35.07,-32.468,63.5,-17.932,63.5,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i8",
    transform: "matrix(1,0,0,1,249.5,249.684)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#face24",
    d: "M63.5,7.231C63.5,7.231,-63.5,7.231,-63.5,7.231C-63.5,7.231,-63.5,-7.231,-63.5,-7.231C-63.5,-7.231,63.5,-7.231,63.5,-7.231C63.5,-7.231,63.5,7.231,63.5,7.231Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i9",
    transform: "matrix(1,0,0,1,249.5,256.532)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de9607",
    d: "M63.5,0C63.5,17.932,35.07,32.468,0,32.468C-35.07,32.468,-63.5,17.932,-63.5,0C-63.5,-17.932,-35.07,-32.468,0,-32.468C35.07,-32.468,63.5,-17.932,63.5,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,249.5,256.532)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b94f01",
    d: "M48.986,0C48.986,13.833,27.054,25.047,0.001,25.047C-27.054,25.047,-48.986,13.833,-48.986,0C-48.986,-13.833,-27.054,-25.047,0.001,-25.047C27.054,-25.047,48.986,-13.833,48.986,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,249.5,255.089)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cd6e13",
    d: "M48.986,0C48.986,13.833,27.054,25.047,0.001,25.047C-27.054,25.047,-48.986,13.833,-48.986,0C-48.986,-13.833,-27.054,-25.047,0.001,-25.047C27.054,-25.047,48.986,-13.833,48.986,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,249.06,254.257)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b94f01",
    d: "M16.326,9.147C16.326,9.147,18.662,11.826,18.662,11.826C18.662,11.826,3.822,15.001,3.822,15.001C3.822,15.001,1.487,12.322,1.487,12.322C-12.941,14.273,-22.366,12.249,-24.435,9.876C-24.435,9.876,-8.351,6.434,-8.351,6.434C-8.351,6.434,-5.201,9.121,5.673,6.794C11.563,5.534,15.739,3.233,14.639,1.97C12.303,-0.708,-2.136,2.153,-6.335,2.734C-14.018,3.787,-27.186,5.333,-30.623,1.391C-33.292,-1.67,-27.518,-5.993,-17.232,-9.148C-17.232,-9.148,-19.567,-11.827,-19.567,-11.827C-19.567,-11.827,-4.728,-15.001,-4.728,-15.001C-4.728,-15.001,-2.392,-12.322,-2.392,-12.322C10.169,-14.102,18.307,-12.936,20.343,-10.602C20.343,-10.602,5.051,-7.331,5.051,-7.331C4.584,-7.866,1.011,-8.419,-6.919,-6.722C-12.356,-5.559,-15.773,-3.466,-14.538,-2.05C-13.07,-0.366,-3.554,-2.402,0.157,-2.923C9.199,-4.268,25.885,-7.02,30.722,-1.471C33.292,1.476,26.953,5.919,16.326,9.147Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,250.286,255.262)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de9607",
    d: "M16.326,9.146C16.326,9.146,18.662,11.826,18.662,11.826C18.662,11.826,3.822,15,3.822,15C3.822,15,1.486,12.321,1.486,12.321C-12.941,14.272,-22.366,12.248,-24.435,9.875C-24.435,9.875,-8.351,6.435,-8.351,6.435C-8.351,6.435,-5.201,9.121,5.673,6.793C11.563,5.534,15.739,3.233,14.638,1.97C12.303,-0.708,-2.137,2.153,-6.335,2.733C-14.018,3.787,-27.186,5.334,-30.623,1.391C-33.293,-1.67,-27.518,-5.994,-17.232,-9.148C-17.232,-9.148,-19.567,-11.827,-19.567,-11.827C-19.567,-11.827,-4.728,-15,-4.728,-15C-4.728,-15,-2.392,-12.323,-2.392,-12.323C10.169,-14.102,18.307,-12.937,20.343,-10.603C20.343,-10.603,5.051,-7.331,5.051,-7.331C4.584,-7.867,1.011,-8.419,-6.919,-6.723C-12.356,-5.56,-15.773,-3.466,-14.538,-2.05C-13.07,-0.367,-3.555,-2.402,0.157,-2.924C9.199,-4.268,25.886,-7.021,30.723,-1.471C33.293,1.475,26.953,5.919,16.326,9.146Z"
  })))))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "i16"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "1.335s",
    begin: "0s",
    fill: "freeze",
    values: "1; 1; 0; 0",
    keyTimes: "0; 0.3485; 0.5235; 1",
    keySplines: "0.167 0 0.833 1; 0.333 0 0.667 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(537,621)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    values: "537 621; 681 103; 957 549; 957 549",
    keyTimes: "0; 0.188775; 0.4985; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 361; 657; 657",
    keyTimes: "0; 0.2; 0.5; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.83,0.83)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    values: "0.83 0.83; 0.6 0.6; 0.4 0.4; 0.4 0.4",
    keyTimes: "0; 0.2; 0.5; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-818,-708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i7",
    transform: "matrix(1,0,0,1,818,717.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b94f01",
    d: "M109,0C109,47.221,60.199,85.5,0,85.5C-60.199,85.5,-109,47.221,-109,0C-109,-47.221,-60.199,-85.5,0,-85.5C60.199,-85.5,109,-47.221,109,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i8",
    transform: "matrix(1,0,0,1,818,703.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bc8d08",
    d: "M109,0C109,47.221,60.199,85.5,0,85.5C-60.199,85.5,-109,47.221,-109,0C-109,-47.221,-60.199,-85.5,0,-85.5C60.199,-85.5,109,-47.221,109,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i9",
    transform: "matrix(1,0,0,1,818,698.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#feea5b",
    d: "M109,0C109,47.221,60.199,85.5,0,85.5C-60.199,85.5,-109,47.221,-109,0C-109,-47.221,-60.199,-85.5,0,-85.5C60.199,-85.5,109,-47.221,109,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,818,698.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c38211",
    d: "M85,0C85,36.823,46.944,66.674,0,66.674C-46.944,66.674,-85,36.823,-85,0C-85,-36.823,-46.944,-66.674,0,-66.674C46.944,-66.674,85,-36.823,85,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,818,702.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#face24",
    d: "M85,0C85,36.823,46.944,66.674,0,66.674C-46.944,66.674,-85,36.823,-85,0C-85,-36.823,-46.944,-66.674,0,-66.674C46.944,-66.674,85,-36.823,85,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,820.657,696.529)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d1770f",
    d: "M20.847,32.113C20.847,32.113,23.681,40.272,23.681,40.272C23.681,40.272,3.467,41.426,3.467,41.426C3.467,41.426,0.633,33.266,0.633,33.266C-18.896,31.41,-31.295,21.539,-33.805,14.312C-33.805,14.312,-11.894,13.062,-11.894,13.062C-11.894,13.062,-7.971,21.634,6.842,20.79C14.866,20.332,20.708,16.313,19.372,12.467C16.538,4.31,-3.107,4.836,-8.791,4.328C-19.193,3.377,-36.991,1.064,-41.162,-10.941C-44.401,-20.265,-36.197,-28.814,-22.081,-32.116C-22.081,-32.116,-24.915,-40.274,-24.915,-40.274C-24.915,-40.274,-4.701,-41.427,-4.701,-41.427C-4.701,-41.427,-1.866,-33.269,-1.866,-33.269C15.145,-31.863,25.914,-24.87,28.384,-17.761C28.384,-17.761,7.553,-16.573,7.553,-16.573C6.987,-18.203,2.264,-21.381,-8.538,-20.765C-15.945,-20.342,-20.748,-16.503,-19.25,-12.191C-17.468,-7.062,-4.507,-7.801,0.519,-7.375C12.773,-6.53,35.414,-5.681,41.284,11.217C44.402,20.191,35.428,28.786,20.847,32.113Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,819.657,693.529)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fefb94",
    d: "M20.847,32.113C20.847,32.113,23.681,40.272,23.681,40.272C23.681,40.272,3.467,41.426,3.467,41.426C3.467,41.426,0.633,33.266,0.633,33.266C-18.896,31.41,-31.295,21.539,-33.805,14.312C-33.805,14.312,-11.894,13.062,-11.894,13.062C-11.894,13.062,-7.971,21.634,6.842,20.79C14.866,20.332,20.708,16.313,19.372,12.467C16.538,4.31,-3.107,4.836,-8.791,4.328C-19.193,3.377,-36.991,1.064,-41.162,-10.941C-44.401,-20.265,-36.197,-28.814,-22.081,-32.116C-22.081,-32.116,-24.915,-40.274,-24.915,-40.274C-24.915,-40.274,-4.701,-41.427,-4.701,-41.427C-4.701,-41.427,-1.866,-33.269,-1.866,-33.269C15.145,-31.863,25.914,-24.87,28.384,-17.761C28.384,-17.761,7.553,-16.573,7.553,-16.573C6.987,-18.203,2.264,-21.381,-8.538,-20.765C-15.945,-20.342,-20.748,-16.503,-19.25,-12.191C-17.468,-7.062,-4.507,-7.801,0.519,-7.375C12.773,-6.53,35.414,-5.681,41.284,11.217C44.402,20.191,35.428,28.786,20.847,32.113Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i10"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    stroke: "#ffffff",
    fill: "#7a8c99",
    d: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "i11"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    stroke: "#ffffff",
    fill: "#7a8c99",
    d: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "i12"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    stroke: "#ffffff",
    fill: "#7a8c99",
    d: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "i13"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    stroke: "#ffffff",
    fill: "#7a8c99",
    d: ""
  })))))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "i17"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "1.335s",
    begin: "0s",
    fill: "freeze",
    values: "1; 1; 0; 0",
    keyTimes: "0; 0.325; 0.6; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672,565)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    values: "672 565; 672 565; 440 293; 208 553; 208 553",
    keyTimes: "0; 0.075; 0.35; 0.6; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(63)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    values: "63; 361; 657; 657",
    keyTimes: "0; 0.175; 0.475; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 0.6 0.6; 0.4 0.4; 0.4 0.4",
    keyTimes: "0; 0.175; 0.4765; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-249.739,-250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,251.411,246.074)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f0d54a",
    d: "M25.517,10.253C24.123,13.722,11.569,11.943,-2.524,6.281C-16.617,0.619,-26.911,-6.784,-25.518,-10.252C-24.124,-13.722,-11.57,-11.943,2.523,-6.281C16.616,-0.619,26.912,6.783,25.517,10.253Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,249.675,250.393)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f0d54a",
    d: "M23.783,14.571C23.783,14.571,-27.252,-5.934,-27.252,-5.934C-27.252,-5.934,-23.782,-14.571,-23.782,-14.571C-23.782,-14.571,27.252,5.934,27.252,5.934C27.252,5.934,23.783,14.571,23.783,14.571Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,248.256,253.926)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d1770f",
    d: "M25.518,10.253C24.124,13.722,11.57,11.943,-2.523,6.281C-16.616,0.619,-26.911,-6.784,-25.517,-10.252C-24.123,-13.722,-11.568,-11.943,2.524,-6.281C16.618,-0.619,26.912,6.783,25.518,10.253Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,248.155,254.176)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#af5700",
    d: "M19.641,7.891C18.786,10.021,9.298,8.215,-1.549,3.857C-12.396,-0.502,-20.497,-5.761,-19.641,-7.891C-18.785,-10.021,-9.298,-8.215,1.549,-3.857C5.284,-2.356,8.694,-0.75,11.524,0.8C16.913,3.751,20.202,6.494,19.641,7.891Z"
  })))))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "i18"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "1.335s",
    begin: "0s",
    fill: "freeze",
    values: "1; 1; 0; 0",
    keyTimes: "0; 0.475; 0.625; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(452,561)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    repeatCount: "indefinite",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    keyTimes: "0; 0.125; 0.325; 0.625; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    keyPoints: "0; 0; 0.471; 1; 1",
    path: "M0 0 C0 0 23.966 -219.317 230 -224 C406 -228 494 -34 472 32",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 0; 361; 657; 657",
    keyTimes: "0; 0.125; 0.325; 0.625; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.56,0.56)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    values: "0.56 0.56; 0.56 0.56; 0.6 0.6; 0.4 0.4; 0.4 0.4",
    keyTimes: "0; 0.125; 0.325; 0.625; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250,-250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i8",
    transform: "matrix(1,0,0,1,254.478,245.36)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#face24",
    d: "M35.515,35.515C18.703,52.327,-10.826,50.056,-30.441,30.442C-50.055,10.828,-52.326,-18.702,-35.514,-35.514C-18.702,-52.327,10.827,-50.055,30.441,-30.441C50.055,-10.827,52.327,18.703,35.515,35.515Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i9",
    transform: "matrix(1,0,0,1,246.36,253.478)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de9607",
    d: "M35.515,35.514C18.703,52.326,-10.827,50.055,-30.441,30.441C-50.055,10.827,-52.327,-18.702,-35.514,-35.514C-18.702,-52.326,10.828,-50.055,30.442,-30.441C50.056,-10.826,52.327,18.702,35.515,35.514Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,246.36,253.478)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b94f01",
    d: "M27.398,27.397C14.428,40.367,-8.353,38.614,-23.484,23.483C-38.615,8.352,-40.366,-14.428,-27.396,-27.397C-14.427,-40.367,8.353,-38.614,23.484,-23.483C38.615,-8.352,40.367,14.427,27.398,27.397Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,247.713,252.125)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cd6e13",
    d: "M27.397,27.398C14.427,40.367,-8.353,38.615,-23.483,23.484C-38.614,8.353,-40.367,-14.427,-27.397,-27.396C-14.428,-40.366,8.352,-38.615,23.483,-23.484C38.614,-8.353,40.367,14.428,27.397,27.398Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,247.434,250.846)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b94f01",
    d: "M1.368,17.96C1.368,17.96,0.163,21.778,0.163,21.778C0.163,21.778,-11.113,16.455,-11.113,16.455C-11.113,16.455,-9.908,12.637,-9.908,12.637C-19.806,6.397,-23.18,-0.772,-22.112,-4.154C-22.112,-4.154,-9.89,1.615,-9.89,1.615C-9.89,1.615,-10.648,5.896,-2.384,9.797C2.092,11.909,6.585,12.087,7.152,10.287C8.358,6.47,-2.401,1.077,-5.293,-0.727C-10.578,-4.036,-19.392,-9.952,-17.618,-15.569C-16.241,-19.933,-8.959,-20.756,-0.248,-17.96C-0.248,-17.96,0.957,-21.778,0.957,-21.778C0.957,-21.778,12.233,-16.456,12.233,-16.456C12.233,-16.456,11.028,-12.638,11.028,-12.638C19.722,-7.281,23.18,-1.637,22.131,1.69C22.131,1.69,10.511,-3.795,10.511,-3.795C10.752,-4.558,9.271,-7.074,3.246,-9.919C-0.885,-11.869,-4.758,-11.818,-5.396,-9.8C-6.153,-7.399,1.076,-3.986,3.641,-2.4C9.96,1.398,21.872,8.149,19.376,16.058C18.05,20.257,10.337,20.878,1.368,17.96Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,247.178,252.473)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de9607",
    d: "M1.368,17.961C1.368,17.961,0.163,21.778,0.163,21.778C0.163,21.778,-11.113,16.456,-11.113,16.456C-11.113,16.456,-9.908,12.638,-9.908,12.638C-19.806,6.398,-23.181,-0.771,-22.113,-4.153C-22.113,-4.153,-9.891,1.616,-9.891,1.616C-9.891,1.616,-10.648,5.897,-2.385,9.797C2.091,11.91,6.585,12.088,7.152,10.288C8.358,6.471,-2.402,1.078,-5.294,-0.726C-10.579,-4.036,-19.392,-9.951,-17.618,-15.569C-16.24,-19.932,-8.959,-20.755,-0.249,-17.96C-0.249,-17.96,0.956,-21.778,0.956,-21.778C0.956,-21.778,12.232,-16.455,12.232,-16.455C12.232,-16.455,11.027,-12.637,11.027,-12.637C19.721,-7.28,23.181,-1.636,22.131,1.691C22.131,1.691,10.51,-3.794,10.51,-3.794C10.751,-4.558,9.27,-7.074,3.245,-9.918C-0.886,-11.869,-4.758,-11.817,-5.396,-9.799C-6.153,-7.399,1.077,-3.986,3.641,-2.399C9.96,1.398,21.872,8.149,19.376,16.059C18.05,20.258,10.337,20.879,1.368,17.961Z"
  })))))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "i19"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "1.335s",
    begin: "0s",
    fill: "freeze",
    values: "1; 1; 0; 0",
    keyTimes: "0; 0.6; 0.75; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,649)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "translate",
    attributeName: "transform",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    values: "416 649; 238 215; 62 463; 62 463",
    keyTimes: "0; 0.425; 0.75; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(548)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    values: "548; 0; 361; 767; 767",
    keyTimes: "0; 0.125; 0.425; 0.75; 1",
    keySplines: "0.167 0 0.833 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.56,0.56)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    values: "0.56 0.56; 0.56 0.56; 0.6 0.6; 0.4 0.4; 0.4 0.4",
    keyTimes: "0; 0.125; 0.425; 0.75; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250,-250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i8",
    transform: "matrix(1,0,0,1,254.478,245.36)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#face24",
    d: "M35.515,35.515C18.703,52.327,-10.826,50.056,-30.441,30.442C-50.055,10.828,-52.326,-18.702,-35.514,-35.514C-18.702,-52.327,10.827,-50.055,30.441,-30.441C50.055,-10.827,52.327,18.703,35.515,35.515Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i9",
    transform: "matrix(1,0,0,1,246.36,253.478)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de9607",
    d: "M35.515,35.514C18.703,52.326,-10.827,50.055,-30.441,30.441C-50.055,10.827,-52.327,-18.702,-35.514,-35.514C-18.702,-52.326,10.828,-50.055,30.442,-30.441C50.056,-10.826,52.327,18.702,35.515,35.514Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,246.36,253.478)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b94f01",
    d: "M27.398,27.397C14.428,40.367,-8.353,38.614,-23.484,23.483C-38.615,8.352,-40.366,-14.428,-27.396,-27.397C-14.427,-40.367,8.353,-38.614,23.484,-23.483C38.615,-8.352,40.367,14.427,27.398,27.397Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,247.713,252.125)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cd6e13",
    d: "M27.397,27.398C14.427,40.367,-8.353,38.615,-23.483,23.484C-38.614,8.353,-40.367,-14.427,-27.397,-27.396C-14.428,-40.366,8.352,-38.615,23.483,-23.484C38.614,-8.353,40.367,14.428,27.397,27.398Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,247.434,250.846)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b94f01",
    d: "M1.368,17.96C1.368,17.96,0.163,21.778,0.163,21.778C0.163,21.778,-11.113,16.455,-11.113,16.455C-11.113,16.455,-9.908,12.637,-9.908,12.637C-19.806,6.397,-23.18,-0.772,-22.112,-4.154C-22.112,-4.154,-9.89,1.615,-9.89,1.615C-9.89,1.615,-10.648,5.896,-2.384,9.797C2.092,11.909,6.585,12.087,7.152,10.287C8.358,6.47,-2.401,1.077,-5.293,-0.727C-10.578,-4.036,-19.392,-9.952,-17.618,-15.569C-16.241,-19.933,-8.959,-20.756,-0.248,-17.96C-0.248,-17.96,0.957,-21.778,0.957,-21.778C0.957,-21.778,12.233,-16.456,12.233,-16.456C12.233,-16.456,11.028,-12.638,11.028,-12.638C19.722,-7.281,23.18,-1.637,22.131,1.69C22.131,1.69,10.511,-3.795,10.511,-3.795C10.752,-4.558,9.271,-7.074,3.246,-9.919C-0.885,-11.869,-4.758,-11.818,-5.396,-9.8C-6.153,-7.399,1.076,-3.986,3.641,-2.4C9.96,1.398,21.872,8.149,19.376,16.058C18.05,20.257,10.337,20.878,1.368,17.96Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,247.178,252.473)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de9607",
    d: "M1.368,17.961C1.368,17.961,0.163,21.778,0.163,21.778C0.163,21.778,-11.113,16.456,-11.113,16.456C-11.113,16.456,-9.908,12.638,-9.908,12.638C-19.806,6.398,-23.181,-0.771,-22.113,-4.153C-22.113,-4.153,-9.891,1.616,-9.891,1.616C-9.891,1.616,-10.648,5.897,-2.385,9.797C2.091,11.91,6.585,12.088,7.152,10.288C8.358,6.471,-2.402,1.078,-5.294,-0.726C-10.579,-4.036,-19.392,-9.951,-17.618,-15.569C-16.24,-19.932,-8.959,-20.755,-0.249,-17.96C-0.249,-17.96,0.956,-21.778,0.956,-21.778C0.956,-21.778,12.232,-16.455,12.232,-16.455C12.232,-16.455,11.027,-12.637,11.027,-12.637C19.721,-7.28,23.181,-1.636,22.131,1.691C22.131,1.691,10.51,-3.794,10.51,-3.794C10.751,-4.558,9.27,-7.074,3.245,-9.918C-0.886,-11.869,-4.758,-11.817,-5.396,-9.799C-6.153,-7.399,1.077,-3.986,3.641,-2.399C9.96,1.398,21.872,8.149,19.376,16.059C18.05,20.258,10.337,20.879,1.368,17.961Z"
  })))))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    id: "i20"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "1.335s",
    begin: "0s",
    fill: "freeze",
    values: "NaN; NaN; 0.007; 0.026; 0.053; 0.087; 0.125; 0.167; 0.211; 0.257; 0.303; 0.351; 0.398; 0.445; 0.492; 0.538; 0.582; 0.625; 0.667; 0.707; 0.745; 0.781; 0.814; 0.846; 0.875; 0.901; 0.925; 0.946; 0.964; 0.979; 0.991; NaN; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; 1; NaN; 0.997; 0.987; 0.972; 0.951; 0.926; 0.896; 0.862; 0.824; 0.784; 0.741; 0.695; 0.648; 0.599; 0.55; 0.5; 0.45; 0.401; 0.352; 0.305; 0.259; 0.216; 0.176; 0.138; 0.104; 0.074; 0.049; 0.028; 0.013; 0.003; 0; 0",
    keyTimes: "0; 0.175; 0.179167; 0.183333; 0.1875; 0.191667; 0.195834; 0.2; 0.204167; 0.208333; 0.2125; 0.216667; 0.220834; 0.225; 0.229167; 0.233333; 0.2375; 0.241667; 0.245834; 0.25; 0.254167; 0.258333; 0.2625; 0.266667; 0.270833; 0.275; 0.279167; 0.283333; 0.2875; 0.291667; 0.295833; 0.3; 0.308333; 0.316667; 0.325; 0.333333; 0.341666; 0.35; 0.358333; 0.366666; 0.375; 0.383333; 0.391666; 0.4; 0.408333; 0.416666; 0.425; 0.433333; 0.441666; 0.45; 0.458334; 0.466667; 0.475; 0.483334; 0.491667; 0.5; 0.508334; 0.516667; 0.525; 0.533333; 0.541667; 0.55; 0.555; 0.56; 0.565; 0.57; 0.575; 0.58; 0.585; 0.59; 0.595; 0.6; 0.605; 0.61; 0.615; 0.62; 0.625; 0.63; 0.635; 0.64; 0.645; 0.65; 0.655; 0.66; 0.665; 0.67; 0.675; 0.68; 0.685; 0.69; 0.695; 0.7; 1",
    calcMode: "linear"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(348,667)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    repeatCount: "indefinite",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    keyTimes: "0; 0.175; 0.5; 0.7; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    keyPoints: "0; 0; 0.474; 1; 1",
    path: "M0 0 C0 0 127.966 -267.317 360 -266 C646 -258 756 -44 734 22",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(497)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    values: "497; 497; 0; 361; 767; 767",
    keyTimes: "0; 0.175; 0.3; 0.5; 0.7; 1",
    keySplines: "0 0 1 1; 0.167 0 0.833 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.84,0.84)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    values: "0.84 0.84; 0.84 0.84; 0.62 0.62; 0.4 0.4; 0.22 0.22; 0.22 0.22",
    keyTimes: "0; 0.175; 0.3; 0.5; 0.725; 1",
    keySplines: "0 0 1 1; 0.167 0 0.833 1; 0.333 0 0.667 1; 0.333 0 0.833 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250,-250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i8",
    transform: "matrix(1,0,0,1,254.478,245.36)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#face24",
    d: "M35.515,35.515C18.703,52.327,-10.826,50.056,-30.441,30.442C-50.055,10.828,-52.326,-18.702,-35.514,-35.514C-18.702,-52.327,10.827,-50.055,30.441,-30.441C50.055,-10.827,52.327,18.703,35.515,35.515Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i9",
    transform: "matrix(1,0,0,1,246.36,253.478)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de9607",
    d: "M35.515,35.514C18.703,52.326,-10.827,50.055,-30.441,30.441C-50.055,10.827,-52.327,-18.702,-35.514,-35.514C-18.702,-52.326,10.828,-50.055,30.442,-30.441C50.056,-10.826,52.327,18.702,35.515,35.514Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,246.36,253.478)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b94f01",
    d: "M27.398,27.397C14.428,40.367,-8.353,38.614,-23.484,23.483C-38.615,8.352,-40.366,-14.428,-27.396,-27.397C-14.427,-40.367,8.353,-38.614,23.484,-23.483C38.615,-8.352,40.367,14.427,27.398,27.397Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,247.713,252.125)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cd6e13",
    d: "M27.397,27.398C14.427,40.367,-8.353,38.615,-23.483,23.484C-38.614,8.353,-40.367,-14.427,-27.397,-27.396C-14.428,-40.366,8.352,-38.615,23.483,-23.484C38.614,-8.353,40.367,14.428,27.397,27.398Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,247.434,250.846)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b94f01",
    d: "M1.368,17.96C1.368,17.96,0.163,21.778,0.163,21.778C0.163,21.778,-11.113,16.455,-11.113,16.455C-11.113,16.455,-9.908,12.637,-9.908,12.637C-19.806,6.397,-23.18,-0.772,-22.112,-4.154C-22.112,-4.154,-9.89,1.615,-9.89,1.615C-9.89,1.615,-10.648,5.896,-2.384,9.797C2.092,11.909,6.585,12.087,7.152,10.287C8.358,6.47,-2.401,1.077,-5.293,-0.727C-10.578,-4.036,-19.392,-9.952,-17.618,-15.569C-16.241,-19.933,-8.959,-20.756,-0.248,-17.96C-0.248,-17.96,0.957,-21.778,0.957,-21.778C0.957,-21.778,12.233,-16.456,12.233,-16.456C12.233,-16.456,11.028,-12.638,11.028,-12.638C19.722,-7.281,23.18,-1.637,22.131,1.69C22.131,1.69,10.511,-3.795,10.511,-3.795C10.752,-4.558,9.271,-7.074,3.246,-9.919C-0.885,-11.869,-4.758,-11.818,-5.396,-9.8C-6.153,-7.399,1.076,-3.986,3.641,-2.4C9.96,1.398,21.872,8.149,19.376,16.058C18.05,20.257,10.337,20.878,1.368,17.96Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,247.178,252.473)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de9607",
    d: "M1.368,17.961C1.368,17.961,0.163,21.778,0.163,21.778C0.163,21.778,-11.113,16.456,-11.113,16.456C-11.113,16.456,-9.908,12.638,-9.908,12.638C-19.806,6.398,-23.181,-0.771,-22.113,-4.153C-22.113,-4.153,-9.891,1.616,-9.891,1.616C-9.891,1.616,-10.648,5.897,-2.385,9.797C2.091,11.91,6.585,12.088,7.152,10.288C8.358,6.471,-2.402,1.078,-5.294,-0.726C-10.579,-4.036,-19.392,-9.951,-17.618,-15.569C-16.24,-19.932,-8.959,-20.755,-0.249,-17.96C-0.249,-17.96,0.956,-21.778,0.956,-21.778C0.956,-21.778,12.232,-16.455,12.232,-16.455C12.232,-16.455,11.027,-12.637,11.027,-12.637C19.721,-7.28,23.181,-1.636,22.131,1.691C22.131,1.691,10.51,-3.794,10.51,-3.794C10.751,-4.558,9.27,-7.074,3.245,-9.918C-0.886,-11.869,-4.758,-11.817,-5.396,-9.799C-6.153,-7.399,1.077,-3.986,3.641,-2.399C9.96,1.398,21.872,8.149,19.376,16.059C18.05,20.258,10.337,20.879,1.368,17.961Z"
  })))))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "i21"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "1.335s",
    begin: "0s",
    fill: "freeze",
    values: "1; 1; 0; 0",
    keyTimes: "0; 0.375; 0.55; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(800,639)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    repeatCount: "indefinite",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    keyTimes: "0; 0.2; 0.525; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    keyPoints: "0; 0.531; 1; 1",
    path: "M0 0 C0 0 -136.034 -367.317 -344 -384 C-470 -396 -600 -90 -622 -24",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 361; 657; 657",
    keyTimes: "0; 0.225; 0.525; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.38,0.38)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    values: "0.38 0.38; 0.6 0.6; 0.4 0.4; 0.4 0.4",
    keyTimes: "0; 0.225; 0.525; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250,-250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i8",
    transform: "matrix(1,0,0,1,254.478,245.36)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#face24",
    d: "M35.515,35.515C18.703,52.327,-10.826,50.056,-30.441,30.442C-50.055,10.828,-52.326,-18.702,-35.514,-35.514C-18.702,-52.327,10.827,-50.055,30.441,-30.441C50.055,-10.827,52.327,18.703,35.515,35.515Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i9",
    transform: "matrix(1,0,0,1,246.36,253.478)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de9607",
    d: "M35.515,35.514C18.703,52.326,-10.827,50.055,-30.441,30.441C-50.055,10.827,-52.327,-18.702,-35.514,-35.514C-18.702,-52.326,10.828,-50.055,30.442,-30.441C50.056,-10.826,52.327,18.702,35.515,35.514Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,246.36,253.478)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b94f01",
    d: "M27.398,27.397C14.428,40.367,-8.353,38.614,-23.484,23.483C-38.615,8.352,-40.366,-14.428,-27.396,-27.397C-14.427,-40.367,8.353,-38.614,23.484,-23.483C38.615,-8.352,40.367,14.427,27.398,27.397Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,247.713,252.125)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cd6e13",
    d: "M27.397,27.398C14.427,40.367,-8.353,38.615,-23.483,23.484C-38.614,8.353,-40.367,-14.427,-27.397,-27.396C-14.428,-40.366,8.352,-38.615,23.483,-23.484C38.614,-8.353,40.367,14.428,27.397,27.398Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,247.434,250.846)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b94f01",
    d: "M1.368,17.96C1.368,17.96,0.163,21.778,0.163,21.778C0.163,21.778,-11.113,16.455,-11.113,16.455C-11.113,16.455,-9.908,12.637,-9.908,12.637C-19.806,6.397,-23.18,-0.772,-22.112,-4.154C-22.112,-4.154,-9.89,1.615,-9.89,1.615C-9.89,1.615,-10.648,5.896,-2.384,9.797C2.092,11.909,6.585,12.087,7.152,10.287C8.358,6.47,-2.401,1.077,-5.293,-0.727C-10.578,-4.036,-19.392,-9.952,-17.618,-15.569C-16.241,-19.933,-8.959,-20.756,-0.248,-17.96C-0.248,-17.96,0.957,-21.778,0.957,-21.778C0.957,-21.778,12.233,-16.456,12.233,-16.456C12.233,-16.456,11.028,-12.638,11.028,-12.638C19.722,-7.281,23.18,-1.637,22.131,1.69C22.131,1.69,10.511,-3.795,10.511,-3.795C10.752,-4.558,9.271,-7.074,3.246,-9.919C-0.885,-11.869,-4.758,-11.818,-5.396,-9.8C-6.153,-7.399,1.076,-3.986,3.641,-2.4C9.96,1.398,21.872,8.149,19.376,16.058C18.05,20.257,10.337,20.878,1.368,17.96Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,247.178,252.473)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de9607",
    d: "M1.368,17.961C1.368,17.961,0.163,21.778,0.163,21.778C0.163,21.778,-11.113,16.456,-11.113,16.456C-11.113,16.456,-9.908,12.638,-9.908,12.638C-19.806,6.398,-23.181,-0.771,-22.113,-4.153C-22.113,-4.153,-9.891,1.616,-9.891,1.616C-9.891,1.616,-10.648,5.897,-2.385,9.797C2.091,11.91,6.585,12.088,7.152,10.288C8.358,6.471,-2.402,1.078,-5.294,-0.726C-10.579,-4.036,-19.392,-9.951,-17.618,-15.569C-16.24,-19.932,-8.959,-20.755,-0.249,-17.96C-0.249,-17.96,0.956,-21.778,0.956,-21.778C0.956,-21.778,12.232,-16.455,12.232,-16.455C12.232,-16.455,11.027,-12.637,11.027,-12.637C19.721,-7.28,23.181,-1.636,22.131,1.691C22.131,1.691,10.51,-3.794,10.51,-3.794C10.751,-4.558,9.27,-7.074,3.245,-9.918C-0.886,-11.869,-4.758,-11.817,-5.396,-9.799C-6.153,-7.399,1.077,-3.986,3.641,-2.399C9.96,1.398,21.872,8.149,19.376,16.059C18.05,20.258,10.337,20.879,1.368,17.961Z"
  })))))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "i22"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "1.335s",
    begin: "0s",
    fill: "freeze",
    values: "1; 1; 0; 0",
    keyTimes: "0; 0.4; 0.575; 1",
    keySplines: "0.167 0 0.833 1; 0.333 0 0.667 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(493,521)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    repeatCount: "indefinite",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    keyTimes: "0; 0.263775; 0.55; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    keyPoints: "0; 0.421; 1; 1",
    path: "M0 0 C0 0 38 -196 172 -222 C272 -230 410 -125 464 28",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(50)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    values: "50; -44.294; -364; -364",
    keyTimes: "0; 0.275; 0.55; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.46,0.46)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    values: "0.46 0.46; 0.31 0.31; 0.16 0.16; 0.16 0.16",
    keyTimes: "0; 0.263775; 0.55; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-818,-708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i7",
    transform: "matrix(1,0,0,1,818,717.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b94f01",
    d: "M109,0C109,47.221,60.199,85.5,0,85.5C-60.199,85.5,-109,47.221,-109,0C-109,-47.221,-60.199,-85.5,0,-85.5C60.199,-85.5,109,-47.221,109,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i8",
    transform: "matrix(1,0,0,1,818,703.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bc8d08",
    d: "M109,0C109,47.221,60.199,85.5,0,85.5C-60.199,85.5,-109,47.221,-109,0C-109,-47.221,-60.199,-85.5,0,-85.5C60.199,-85.5,109,-47.221,109,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i9",
    transform: "matrix(1,0,0,1,818,698.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#feea5b",
    d: "M109,0C109,47.221,60.199,85.5,0,85.5C-60.199,85.5,-109,47.221,-109,0C-109,-47.221,-60.199,-85.5,0,-85.5C60.199,-85.5,109,-47.221,109,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,818,698.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c38211",
    d: "M85,0C85,36.823,46.944,66.674,0,66.674C-46.944,66.674,-85,36.823,-85,0C-85,-36.823,-46.944,-66.674,0,-66.674C46.944,-66.674,85,-36.823,85,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,818,702.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#face24",
    d: "M85,0C85,36.823,46.944,66.674,0,66.674C-46.944,66.674,-85,36.823,-85,0C-85,-36.823,-46.944,-66.674,0,-66.674C46.944,-66.674,85,-36.823,85,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,820.657,696.529)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d1770f",
    d: "M20.847,32.113C20.847,32.113,23.681,40.272,23.681,40.272C23.681,40.272,3.467,41.426,3.467,41.426C3.467,41.426,0.633,33.266,0.633,33.266C-18.896,31.41,-31.295,21.539,-33.805,14.312C-33.805,14.312,-11.894,13.062,-11.894,13.062C-11.894,13.062,-7.971,21.634,6.842,20.79C14.866,20.332,20.708,16.313,19.372,12.467C16.538,4.31,-3.107,4.836,-8.791,4.328C-19.193,3.377,-36.991,1.064,-41.162,-10.941C-44.401,-20.265,-36.197,-28.814,-22.081,-32.116C-22.081,-32.116,-24.915,-40.274,-24.915,-40.274C-24.915,-40.274,-4.701,-41.427,-4.701,-41.427C-4.701,-41.427,-1.866,-33.269,-1.866,-33.269C15.145,-31.863,25.914,-24.87,28.384,-17.761C28.384,-17.761,7.553,-16.573,7.553,-16.573C6.987,-18.203,2.264,-21.381,-8.538,-20.765C-15.945,-20.342,-20.748,-16.503,-19.25,-12.191C-17.468,-7.062,-4.507,-7.801,0.519,-7.375C12.773,-6.53,35.414,-5.681,41.284,11.217C44.402,20.191,35.428,28.786,20.847,32.113Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,819.657,693.529)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fefb94",
    d: "M20.847,32.113C20.847,32.113,23.681,40.272,23.681,40.272C23.681,40.272,3.467,41.426,3.467,41.426C3.467,41.426,0.633,33.266,0.633,33.266C-18.896,31.41,-31.295,21.539,-33.805,14.312C-33.805,14.312,-11.894,13.062,-11.894,13.062C-11.894,13.062,-7.971,21.634,6.842,20.79C14.866,20.332,20.708,16.313,19.372,12.467C16.538,4.31,-3.107,4.836,-8.791,4.328C-19.193,3.377,-36.991,1.064,-41.162,-10.941C-44.401,-20.265,-36.197,-28.814,-22.081,-32.116C-22.081,-32.116,-24.915,-40.274,-24.915,-40.274C-24.915,-40.274,-4.701,-41.427,-4.701,-41.427C-4.701,-41.427,-1.866,-33.269,-1.866,-33.269C15.145,-31.863,25.914,-24.87,28.384,-17.761C28.384,-17.761,7.553,-16.573,7.553,-16.573C6.987,-18.203,2.264,-21.381,-8.538,-20.765C-15.945,-20.342,-20.748,-16.503,-19.25,-12.191C-17.468,-7.062,-4.507,-7.801,0.519,-7.375C12.773,-6.53,35.414,-5.681,41.284,11.217C44.402,20.191,35.428,28.786,20.847,32.113Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i10"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    stroke: "#ffffff",
    fill: "#7a8c99",
    d: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "i11"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    stroke: "#ffffff",
    fill: "#7a8c99",
    d: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "i12"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    stroke: "#ffffff",
    fill: "#7a8c99",
    d: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "i13"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    stroke: "#ffffff",
    fill: "#7a8c99",
    d: ""
  })))))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "i23"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "1.335s",
    begin: "0s",
    fill: "freeze",
    values: "1; 1; 1; 0; 0",
    keyTimes: "0; 0.15; 0.475; 0.65; 1",
    keySplines: "0 0 1 1; 0.167 0 0.833 1; 0.333 0 0.667 1; 0 0 1 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(708,648)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    repeatCount: "indefinite",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    keyTimes: "0; 0.15; 0.45; 0.65; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    keyPoints: "0; 0; 0.448; 1; 1",
    path: "M0 0 C0 0 -24 -215 74 -217 C212 -205 340 -67 340 -67",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-248)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    values: "-248; -248; 219; 260.225; 415; 415",
    keyTimes: "0; 0.15; 0.286225; 0.475; 0.65; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 0; 0.333 0.486 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.78,0.78)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "1.335s",
    begin: "0s",
    calcMode: "spline",
    values: "0.78 0.78; 0.58 0.58; 0.4 0.4; 0.4 0.4",
    keyTimes: "0; 0.15; 0.65; 1",
    keySplines: "0.167 0 0.833 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-249.5,-249.462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i7",
    transform: "matrix(1,0,0,1,249.5,242.392)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#face24",
    d: "M63.5,0C63.5,17.932,35.07,32.468,0,32.468C-35.07,32.468,-63.5,17.932,-63.5,0C-63.5,-17.932,-35.07,-32.468,0,-32.468C35.07,-32.468,63.5,-17.932,63.5,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i8",
    transform: "matrix(1,0,0,1,249.5,249.684)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#face24",
    d: "M63.5,7.231C63.5,7.231,-63.5,7.231,-63.5,7.231C-63.5,7.231,-63.5,-7.231,-63.5,-7.231C-63.5,-7.231,63.5,-7.231,63.5,-7.231C63.5,-7.231,63.5,7.231,63.5,7.231Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i9",
    transform: "matrix(1,0,0,1,249.5,256.532)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de9607",
    d: "M63.5,0C63.5,17.932,35.07,32.468,0,32.468C-35.07,32.468,-63.5,17.932,-63.5,0C-63.5,-17.932,-35.07,-32.468,0,-32.468C35.07,-32.468,63.5,-17.932,63.5,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i1",
    transform: "matrix(1,0,0,1,249.5,256.532)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b94f01",
    d: "M48.986,0C48.986,13.833,27.054,25.047,0.001,25.047C-27.054,25.047,-48.986,13.833,-48.986,0C-48.986,-13.833,-27.054,-25.047,0.001,-25.047C27.054,-25.047,48.986,-13.833,48.986,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i2",
    transform: "matrix(1,0,0,1,249.5,255.089)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cd6e13",
    d: "M48.986,0C48.986,13.833,27.054,25.047,0.001,25.047C-27.054,25.047,-48.986,13.833,-48.986,0C-48.986,-13.833,-27.054,-25.047,0.001,-25.047C27.054,-25.047,48.986,-13.833,48.986,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "matrix(1,0,0,1,249.06,254.257)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b94f01",
    d: "M16.326,9.147C16.326,9.147,18.662,11.826,18.662,11.826C18.662,11.826,3.822,15.001,3.822,15.001C3.822,15.001,1.487,12.322,1.487,12.322C-12.941,14.273,-22.366,12.249,-24.435,9.876C-24.435,9.876,-8.351,6.434,-8.351,6.434C-8.351,6.434,-5.201,9.121,5.673,6.794C11.563,5.534,15.739,3.233,14.639,1.97C12.303,-0.708,-2.136,2.153,-6.335,2.734C-14.018,3.787,-27.186,5.333,-30.623,1.391C-33.292,-1.67,-27.518,-5.993,-17.232,-9.148C-17.232,-9.148,-19.567,-11.827,-19.567,-11.827C-19.567,-11.827,-4.728,-15.001,-4.728,-15.001C-4.728,-15.001,-2.392,-12.322,-2.392,-12.322C10.169,-14.102,18.307,-12.936,20.343,-10.602C20.343,-10.602,5.051,-7.331,5.051,-7.331C4.584,-7.866,1.011,-8.419,-6.919,-6.722C-12.356,-5.559,-15.773,-3.466,-14.538,-2.05C-13.07,-0.366,-3.554,-2.402,0.157,-2.923C9.199,-4.268,25.885,-7.02,30.722,-1.471C33.292,1.476,26.953,5.919,16.326,9.147Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,250.286,255.262)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#de9607",
    d: "M16.326,9.146C16.326,9.146,18.662,11.826,18.662,11.826C18.662,11.826,3.822,15,3.822,15C3.822,15,1.486,12.321,1.486,12.321C-12.941,14.272,-22.366,12.248,-24.435,9.875C-24.435,9.875,-8.351,6.435,-8.351,6.435C-8.351,6.435,-5.201,9.121,5.673,6.793C11.563,5.534,15.739,3.233,14.638,1.97C12.303,-0.708,-2.137,2.153,-6.335,2.733C-14.018,3.787,-27.186,5.334,-30.623,1.391C-33.293,-1.67,-27.518,-5.994,-17.232,-9.148C-17.232,-9.148,-19.567,-11.827,-19.567,-11.827C-19.567,-11.827,-4.728,-15,-4.728,-15C-4.728,-15,-2.392,-12.323,-2.392,-12.323C10.169,-14.102,18.307,-12.937,20.343,-10.603C20.343,-10.603,5.051,-7.331,5.051,-7.331C4.584,-7.867,1.011,-8.419,-6.919,-6.723C-12.356,-5.56,-15.773,-3.466,-14.538,-2.05C-13.07,-0.367,-3.555,-2.402,0.157,-2.924C9.199,-4.268,25.886,-7.021,30.723,-1.471C33.293,1.475,26.953,5.919,16.326,9.146Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChips);
export default __webpack_public_path__ + "static/media/chips.6e75e9ea34dcbb2744f143a58cc1cc4b.svg";
export { ForwardRef as ReactComponent };